import React, { Component } from "react";
import { tableConfig, formGroup } from "./config";
import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import Container from "../../../modules/commons/Container";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Api from "../../../Services/Api";
import { defaultTableChange } from "../../../modules/custom/customTable";
import SimpleInput from "../../../modules/SimpleInput";
import {
  flattenFormGroupObject,
  getValueFromDDL,
  mapToObjectDDL,
  removeNullFields,
} from "../../common/mapper";
import SimpleDDL from "../../../modules/SimpleDDL";
import { contructQueryParam, getUserAccess } from "../../../Services/Utils";
import * as R from "ramda";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import ClaimC1Filter from "./claimC1Filter";
import ClaimC1Modifying from "./claimC1Modifying";
import { ACTIVITY_TYPE } from "../../common/Constants";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import { Scanner } from "@yudiel/react-qr-scanner";
import M from "moment/moment";

class ClaimC1 extends Component {
  tableColumns = [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    ...tableConfig,
    {
      name: "claimNo",
      label: "Aksi",
      options: {
        customBodyRender: (val, { rowIndex }) => {
          return (
            <FlexView
              vAlignContent="center"
              style={{ justifyContent: "center" }}
            >
              <SimpleButton
                category="action_button"
                className="btnAct"
                onClick={() => {
                  this.handleModifyingVisibility(val);
                  this.setState((prevValue) => ({
                    ...prevValue,
                    activityTypes: ACTIVITY_TYPE.UPDATE,
                  }));
                }}
                icon={
                  <i
                    className="fa fa-lw fa-pencil-alt"
                    style={{
                      backgroundColor: "transparent",
                      color: "red",
                      fontSize: 20,
                    }}
                  />
                }
              />
              <SimpleButton
                category="action_button"
                className="btnAct margin-left-15px"
                onClick={() => {
                  this.handleModifyingVisibility(val);
                  this.setState((prevValue) => ({
                    ...prevValue,
                    activityTypes: ACTIVITY_TYPE.VIEW,
                  }));
                }}
                icon={
                  <i
                    className="fa fa-eye"
                    style={{
                      backgroundColor: "transparent",
                      color: "red",
                      fontSize: 20,
                    }}
                  />
                }
              />
            </FlexView>
          );
        },
        sort: false,
      },
    },
  ];

  constructor(props) {
    super(props);
    this.state = {
      userAccess: null,
      loading: false,
      dataTable: [],
      pagination: {
        totalData: 0,
        limit: 5,
        page: 1,
      },
      selectedData: null,
      submittedFilterData: {},
      filterData: {
        claimDate: {
          tanggalAwal: null,
          tanggalAkhir: null,
        },
      },
      search: {
        engineNumber: "",
      },
      dataCabang: [],
      filterVisible: false,
      modifyingVisible: false,
      printVisible: false,
      scannerVisible: false,
      activityTypes: ACTIVITY_TYPE.CREATE,
      deleteId: "",
      warningAlertVisible: false,
      warningAlertMessage: "",
      options: {
        locatorOptions: [],
        statusOptions: [],
      },
      skipNextPagination: false
    };
  }

  async componentDidMount() {
    this.handleTriggerLoading();
    await this.fetchDataCabang();
    await this.fetchClaimStatusOptions();
    this.handleTriggerLoading();
  }

  componentDidUpdate = async (prevProps, prevState) => {
    if (
      (prevState.pagination.page !== this.state.pagination.page ||
      prevState.pagination.limit !== this.state.pagination.limit) && !this.state.skipNextPagination
    ) {
      this.handleTriggerLoading()
      await this.fetchData(
        this.state.submittedFilterData,
        this.state.pagination.page,
        this.state.pagination.limit
      );
      this.handleTriggerLoading()
    }
    if(this.state.skipNextPagination){
      this.setState({skipNextPagination:false})
    }

    if (!R.equals(this.state.search.kodeCabang, prevState.search.kodeCabang)) {
      this.handleTriggerLoading()
      await this.fetchData(
        removeNullFields(this.parseFilterData(this.state.search)),
        1,
        5
      );
      await this.fetchLokasiOptions(this.state.search.kodeCabang.value);
      this.setState((prevState) => ({
        ...prevState,
        userAccess: getUserAccess(
          this.props.menuAccess,
          this.state.search.kodeCabang.value
        ),
      }));
      this.handleTriggerLoading()
    }
  };

  fetchLokasiOptions = async (value) => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: value },
      });
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          options: {
            ...prevValue.options,
            locatorOptions: response.data.data.map((item) =>
              mapToObjectDDL(item.kodeLocation, item.kodeLocation)
            ),
          },
        }));
      }
    } catch (errors) {
      console.log("errors", errors);
    }
  };

  fetchClaimStatusOptions = async () => {
    try {
      let response = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getAllBizparByParam({
        paramFilters: { bizparCategory: "CLAIM_C1_TYPE" },
      });
      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          options: {
            ...prevValue.options,
            statusOptions: response.data.data.map((item) =>
              mapToObjectDDL(item.value, item.key)
            ),
          },
        }));
      }
    } catch (errors) {
      console.log("errors", errors);
    }
  };

  handleSubmitModifying = async (controls, activityType) => {
    this.handleTriggerLoading();
    const formData = flattenFormGroupObject(controls);
    const request = {
      claimNo: R.equals(activityType, "CREATE") ? null : formData.claimNo,
      claimDate: formData.claimDate || M(new Date()).format("DD-MM-YYYY"),
      kodeCabang: formData.kodeCabang || this.state.search.kodeCabang.value,
      engineNumber: formData.engineNumber.value,
      frameNumber: formData.frameNumber,
      chronology: formData.chronology,
      claimStatus: formData.claimStatus.value,
      hotlineOrder: formData.hotlineOrder,
      noFjb: formData.noFjb,
    };
    try {
      await Api.create("NAGAMAS_TRANSACTION").submitClaimC1(request);
    } catch (error) {
      console.log("error", error);
    }
    this.handleRefreshPagination()
    await this.fetchData(
      this.state.submittedFilterData,
      this.state.pagination.page,
      this.state.pagination.limit
    );
    this.handleTriggerLoading();
    this.handleModifyingVisibility();
    this.handleWarningAlertVisibility("Data Claim C1 unit berhasil disimpan.");
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
        totalData: 0,
      },
    }));
  };

  handleChangeRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
        totalData: 0,
      },
    }));
  };

  fetchData = async (filter, page = 1, limit = 5) => {
    const response = await Api.create("NAGAMAS_TRANSACTION").findAllClaimC1({
      paramFilters: {
        ...filter,
        kodeCabang: this.state.search.kodeCabang.value,
      },
      page,
      limit,
    });
    if (response.ok) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: response.data.data,
        pagination: {
          ...prevValue.pagination,
          totalData: response.data.totalData,
        },
      }));
    }
  };

  fetchDataCabang = async () => {
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang)
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            search: {
              ...prevValue.search,
              kodeCabang: mapToObjectDDL(
                filteredData[0].namaDealer,
                filteredData[0].kodeCabang
              ),
            },
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  handleOnScanQRCode = async (data) => {
    if (!R.isNil(data)) {
      this.handleTriggerLoading();
      const value = data.length > 0 ? data[0]?.rawValue : "";
      
      const result = await Api.create("NAGAMAS_TRANSACTION").findBarcodeUnitMutation({
        nameCategory: "UNIT",
        encryptBarcode: value,
        kodeCabang: this.state.search?.kodeCabang?.value,
        trxType : "TRX_IN"
      })
    
      if(result.ok && result.data.data){
        this.setState((prevValue) => ({
          ...prevValue,
          search: {
            ...prevValue.search,
            engineNumber: result.data.data?.noSin,
          },
        }), ()=>{
          this.handleSearch()
        });
        return;
      }else{
        this.setState({ dataTable: [] })
      }
    }
    this.handleScannerVisibility();
    this.handleTriggerLoading();
  };

  handleSearch = async () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: true,
      filterData: {},
    }));
    const request = removeNullFields({
      engineNumber: !R.isNil(this.state.search.engineNumber)
        ? this.state.search.engineNumber
        : "",
    });
    await this.fetchData(request, 1, this.state.pagination.limit);
    this.setState((prevValue) => ({
      ...prevValue,
      loading: false,
      submittedFilterData: request,
    }));
  };

  handleShowAlert = (id) => {
    if (id) {
      this.setState((prevValue) => ({ ...prevValue, deleteId: id }));
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        deleteId: "",
        loading: false,
      }));
    }
  };

  handleSubmitDelete = async () => {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    await Api.create("NAGAMAS_TRANSACTION").deleteClaimC1(this.state.deleteId);
    this.handleModifyingVisibility();
    await this.fetchData();
    this.handleShowAlert();
  };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        ...prevValue.search,
        [name]: value,
      },
    }));
  };

  parseFilterData(data) {
    return {
      ...data,
      kodeCabang: getValueFromDDL(data, "kodeCabang"),
    };
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleFilterVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: !prevValue.filterVisible,
    }));
  };

  handlePrint = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      printVisible: !prevValue.printVisible,
    }));
  };

  handleScannerVisibility = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      scannerVisible: !prevValue.scannerVisible,
    }));
  };

  handleModifyingVisibility = async (id) => {
    this.handleTriggerLoading();
    if (typeof id == "string") {
      const response = await Api.create("NAGAMAS_TRANSACTION").findByClaimNo(
        contructQueryParam({ claimNo: id })
      );
      if (response.ok && !R.isNil(response.data.data)) {
        this.setState((prevValue) => ({
          ...prevValue,
          selectedData: {
            ...response.data.data,
            engineNumber: mapToObjectDDL(
              response.data.data.engineNumber,
              response.data.data.engineNumber
            ),
            claimStatus: mapToObjectDDL(
              response.data.data.unitDetail.claimStatusDTO.value,
              response.data.data.unitDetail.claimStatusDTO.key
            ),
            locator: mapToObjectDDL(
              response.data.data.unitDetail.locator.kodeLocation,
              response.data.data.unitDetail.locator.kodeLocation
            ),
            noSPBM: response.data.data.spbmNo,
            noSJ: response.data.data.slNo,
            warna: response.data.data.unitDetail.warna.namaWarnaKomersil,
            variant: response.data.data.unitDetail.variant.namaVariant,
            series: response.data.data.unitDetail.series.seriesName,
            type: response.data.data.unitDetail.type.typeName,
          },
          modifyingVisible: !prevValue.modifyingVisible,
        }));
      }
    } else {
      this.setState((prevValue) => ({
        ...prevValue,
        selectedData: null,
        modifyingVisible: !prevValue.modifyingVisible,
      }));
    }
    this.handleTriggerLoading();
  };

  handleStateChange = (callback) => {
    console.log("callback", callback);
    this.setState(callback);
  };

  handleSubmitFilter = async () => {
    this.handleTriggerLoading();
    const request = removeNullFields({
      ...this.state.filterData,
      kodeLocator: getValueFromDDL(this.state.filterData, "kodeLocator"),
      claimStatus: getValueFromDDL(this.state.filterData, "claimStatus"),
    });
    this.handleRefreshPagination()
    await this.fetchData(request, 1, this.state.pagination.limit);
    this.setState((prevValue) => ({
      ...prevValue,
      filterVisible: false,
      submittedFilterData: request,
    }));
    this.handleTriggerLoading();
  };

  handleWarningAlertVisibility = (text) => {
    this.setState((prevValue) => ({
      ...prevValue,
      warningAlertVisible: !prevValue.warningAlertVisible,
      warningAlertMessage: text,
    }));
  };
   
handleRefreshPagination = () => {
  this.setState((prevState) => ({
    ...prevState.pagination,
    skipNextPagination: true
  }));
};

  render() {
    return (
      <>
        <Container>
          <FlexView>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-250px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang)
              )}
              value={this.state.search.kodeCabang}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
          </FlexView>
          <FlexView
            style={{
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <FlexView vAlignContent="center">
              <SimpleInput
                id="input_text_engine_number"
                placeholder="Cari No. Mesin untuk di Claim: "
                name="engineNumber"
                containerclassname="margin-bottom-5px width width-250px"
                value={this.state.search.engineNumber}
                onChange={({ target }) => {
                  this.setState((prevValue) => ({
                    ...prevValue,
                    search: {
                      ...prevValue.search,
                      [target.name]: target.value,
                    },
                  }));
                }}
              />
              <SimpleButton onClick={this.handleSearch}>Cari</SimpleButton>
              <SimpleButton
                className="btn background-red margin-left-10px margin-right-10px"
                category="action_button"
                onClick={this.handleScannerVisibility}
                icon={<i className="fa fa-qrcode"></i>}
              />
            </FlexView>
            <SimpleButton
              className="btn background-red"
              category="action_button"
              onClick={this.handleFilterVisibility}
              icon={<i className="fa fa-filter"></i>}
            />
          </FlexView>
          <SimpleDataTable
            data={this.state.dataTable}
            columns={this.tableColumns}
            toCount={this.state.pagination.totalData}
            rowsPerPage={this.state.pagination.limit}
            page={this.state.pagination.page - 1}
            options={defaultTableChange(
              (tableState) => this.handleChangePage(tableState),
              (tableState) => this.handleChangeRowsPerPage(tableState)
            )}
            footerAdditionalButtons={
              <>
                <SimpleButton
                  icon={<i className="fa fa-plus margin-right-10px" />}
                  onClick={() => {
                    this.handleModifyingVisibility();
                    this.setState((prevValue) => ({
                      ...prevValue,
                      activityTypes: ACTIVITY_TYPE.CREATE,
                    }));
                  }}
                >
                  Tambah
                </SimpleButton>
                <SimpleButton onClick={this.handlePrint}>Cetak</SimpleButton>
              </>
            }
          />
        </Container>

        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
        {this.state.filterVisible && (
          <ClaimC1Filter
            state={this.state}
            onSetState={this.handleStateChange}
            onClickClose={this.handleFilterVisibility}
            onSubmit={this.handleSubmitFilter}
          />
        )}
        {this.state.modifyingVisible && (
          <ClaimC1Modifying
            formGroup={formGroup}
            initialValues={this.state.selectedData}
            dataCabang={this.state.search.kodeCabang}
            userAccess={this.state.userAccess}
            visible={this.state.modifyingVisible}
            activityTypes={this.state.activityTypes}
            onClickClose={this.handleModifyingVisibility}
            onSubmit={this.handleSubmitModifying}
            onDelete={() =>
              this.setState((preValue) => ({
                ...preValue,
                deleteId: this.state.selectedData.claimNo,
              }))
            }
          />
        )}
        {this.state.printVisible && (
          <SimplePrintTable onClearPrint={this.handlePrint} />
        )}
        {this.state.deleteId !== "" && (
          <SimpleAlert
            visible={this.state.deleteId !== ""}
            onClickClose={() => this.handleShowAlert()}
            content={
              "Anda yakin untuk menghapus data Claim C1 Unit ini? Proses ini tidak bisa di rollback."
            }
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton secondary onClick={() => this.handleShowAlert()}>
                  Batal
                </SimpleButton>
                <SimpleButton onClick={this.handleSubmitDelete}>
                  Iya
                </SimpleButton>
              </FlexView>
            }
          />
        )}
        {this.state.scannerVisible && (
          <SimpleAlert
            title={"Scan QR Here"}
            visible={this.state.scannerVisible}
            onClickClose={this.handleScannerVisibility}
            additionalButtons={
              <Scanner
                onScan={(result) => this.handleOnScanQRCode(result)}
                constraints={{
                  height: { ideal: "720" },
                  video: {
                    facingMode: { exact: "environment" },
                    height: { ideal: 720 },
                  },
                }}
              />
            }
          />
        )}
        {this.state.warningAlertVisible && (
          <SimpleAlert
            title="Claim C1 Unit"
            visible={this.state.warningAlertVisible}
            onClickClose={() => this.handleWarningAlertVisibility()}
            content={this.state.warningAlertMessage}
            additionalButtons={
              <FlexView vAlignContent="center" style={{ gap: "10px" }}>
                <SimpleButton
                  secondary
                  onClick={() => this.handleWarningAlertVisibility()}
                >
                  OK
                </SimpleButton>
              </FlexView>
            }
          />
        )}
      </>
    );
  }
}

export default ClaimC1;